import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from "prop-types";

import FirstHeader from '../components/firstHeader'
import Header from '../components/header'
import Fastbooking from '../components/fastbooking';
import Middlesection from '../components/middleSection'
import SectionInformationBoxes from '../components/sectionInformationBoxes'
import Footer from '../components/footer'
import LastFooter from '../components/lastFooter'

import SectionCities from './components/sectionCities'

class home extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].home

    return (
      <div className='route-home'>
        <FirstHeader />
        <Header isMenu={true} />

        <Fastbooking />
        <Middlesection smallTitle={langPlace.title} title={langPlace.subtitle}/>
        <SectionCities/>
        <SectionInformationBoxes/>

        <Footer />
      </div>
    )
  }
}

export default connect(
  (state) => ({settings: state.settings})
)(home)



// WEBPACK FOOTER //
// ./src/shared/routes/routeHome/index.js